/**
 * 未ログインユーザーでもアクセス可能なページでAPIが404を返した場合に404エラーページを表示するガード
 */

import { useError404WithProvider } from '@src/hooks/useError404';
import Error404 from '@src/pages/Error404';

type Props = {
  children: React.ReactNode;
  isTenant: boolean;
};

const Error404Guard: React.FC<Props> = ({ children, isTenant }) => {
  const { isNotFound, ProviderComponent } = useError404WithProvider();

  if (isNotFound) {
    return (
      <ProviderComponent>
        <Error404 isTenant={isTenant} />
      </ProviderComponent>
    );
  }

  return <ProviderComponent>{children}</ProviderComponent>;
};

export default Error404Guard;
